const safeParseJSON = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn("Failed to parse JSON from localStorage:", error);
        return null;
    }
};

const decodeJwtPayload = (token) => {
    if (!token) return null;
    try {
        if (typeof atob !== "function") return null;
        const base64Url = token.split(".")[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.warn("Failed to decode JWT payload:", error);
        return null;
    }
};

const readFromLocalStorage = (key) => {
    if (typeof window === "undefined") return null;
    try {
        return window.localStorage.getItem(key);
    } catch (error) {
        console.warn(`Unable to read ${key} from localStorage`, error);
        return null;
    }
};

export const getUserContext = () => {
    const accessToken = readFromLocalStorage("accessToken");
    const payload = decodeJwtPayload(accessToken);
    const business = safeParseJSON(readFromLocalStorage("activeBusiness"));

    return {
        userId: payload?.userId || null,
        userEmail: payload?.userEmail || null,
        userType: payload?.userType || null,
        tokenPayload: payload,
        accessToken: accessToken || null,
        businessId: business?._id || null,
        business,
        isAuthenticated: Boolean(accessToken && payload?.userId),
    };
};

export const clearUserContext = () => {
    if (typeof window === "undefined") return;
    try {
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem("activeBusiness");
        window.localStorage.removeItem("isAuthenticated");
    } catch (error) {
        console.warn("Failed to clear user context from localStorage", error);
    }
};
